export const DEFAULT_ERROR_MESSAGE =
  'An unknown error occurred while performing client request';
